import { ContextMenu, ContextMenuContainer } from 'components';
import BasicConfirmation from 'components/ConfirmationPopup/BasicConfirmation';
import { ContextMenuOrientation, ORIENTATION_BOTTOM_RIGHT } from 'components/ContextMenu/constants';
import { ContextMenuRenderProps } from 'components/ContextMenu/ContextMenu';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  callback: (args: any) => void;
  children: JSX.Element;
  orientation?: ContextMenuOrientation;
};

const ApproveConfirmation: React.FunctionComponent<Props> = ({ children, callback, orientation }: Props) => {
  const { t } = useTranslation('organization');

  return (
    <ContextMenu
      enhanceWithOnContext={false}
      orientation={orientation || ORIENTATION_BOTTOM_RIGHT}
      content={
        <ContextMenuContainer>
          <BasicConfirmation
            callback={callback}
            cancelText={t('detail.approve.cancel')}
            confirmText={t('detail.approve.confirm')}
            primary
            description={t('detail.approve.description')}
          />
        </ContextMenuContainer>
      }
    >
      {({ toggleMenu }: ContextMenuRenderProps) => React.cloneElement(children, { onClick: toggleMenu })}
    </ContextMenu>
  );
};

export default ApproveConfirmation;
